import axios from 'axios'
import api from '../api/apiConfig'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async update ({state, commit, dispatch}, user) {
      await api.updateMember(user)
    },
    async add ({state, commit, dispatch, rootState}, newUser) {
      await axios.post('/member', {...newUser, belongTo: rootState.project.current._id})
    },
    async delete ({state, dispatch}, id) {
      await axios.delete(`/member/${id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/member.js